<template>
    <div class="content mt20 bgfff">
       <div class="power">
            <div class="title">权限调整</div>
            <div class="form-group1 clearfix">
              <label class="control-label">用户组：</label>
              <div class="fl">
                <div class="radio radio1 fl">
                  <input type="radio" v-model="sel" @click="typeCheck(1)" value="1" class="radio-i">
                  <span class="radio-ico"></span>
                </div>
                <span class="ml5">管理员</span>
              </div>
              <div class="fl">
                <div class="radio ml30 fl">
                  <input type="radio" v-model="sel" @click="typeCheck(2)" value="2" class="radio-i">
                  <span class="radio-ico"></span>
                </div>
                <span class="ml5">普通用户</span>
              </div>
            </div>
            <div class="form-group1 clearfix" v-if="sel==1">
                <label class="control-label">用户管理：</label>
                <div class="fl">
                  <div class="checkbox fl">
                    <input type="checkbox" class="checkbox-i" disabled v-model="active">
                    <span class="checkbox-ico gray"></span>
                  </div>
                  <span class="ml5">添加账号</span>
                </div>
                <div class="fl">
                  <div class="checkbox ml30 fl">
                    <input type="checkbox" class="checkbox-i" disabled v-model="active1">
                    <span class="checkbox-ico gray"></span>
                  </div>
                  <span class="ml5">删除账号</span>
                </div>
                <div class="fl">
                  <div class="checkbox ml30 fl">
                    <input type="checkbox" class="checkbox-i" disabled v-model="active2">
                    <span class="checkbox-ico gray"></span>
                  </div>
                  <span class="ml5">权限调整</span>
                </div>
            </div>
            <div class="form-group1 clearfix">
              <label class="control-label">媒体榜单：</label>
              <div class="fl">
                <div class="checkbox fl">
                  <input type="checkbox" class="checkbox-i" @click="mtlistChecked()" v-model="active3">
                  <span class="checkbox-ico"></span>
                </div>
                <span class="ml5">查看所有媒体号榜单</span>
              </div>
            </div>
            <div class="form-group1 clearfix">
              <label class="control-label">任务平台：</label>
              <div class="fl">
                <div class="checkbox fl">
                  <input type="checkbox" class="checkbox-i" @click="taskChecked()" v-model="active4">
                  <span class="checkbox-ico"></span>
                </div>
                <span class="ml5">任务派发</span>
              </div>
            </div>
            <div class="form-group1 clearfix">
              <label class="control-label mt10">可授权微信：</label>
              <div class="checkbox fl">
                  <input type="number" autocomplete="off" min="0" v-model="wxnum" class="input-text input-numb w80" />
                  <span>个</span>
              </div>
            </div>
            <div class="form-group1 clearfix">
              <label class="control-label mt10">可授权微博：</label>
              <div class="checkbox fl">
                  <input type="number" autocomplete="off" min="0" v-model="wbnum" class="input-text input-numb w80" />
                  <span>个</span>
              </div>
            </div>
            <div class="form-group1 clearfix">
              <label class="control-label mt10">可授权头条：</label>
              <div class="checkbox fl">
                  <input type="number" autocomplete="off" min="0" v-model="ttnum" class="input-text input-numb w80" />
                  <span>个</span>
              </div>
            </div>
            <div class="btn-div mt50 ml20 clearfix">
                <button class="btn btn-blue fl" @click="dataAjax">保存</button>
                <button class="btn btn-white ml20 fl" @click="cancel">返回</button>
            </div>
       </div>
	</div>
</template>
<script>
export default {
    data() {
        return {
          typeId : '',
          sel:'',//管理员
          type:'',
          wxnum:'',//微信数
          wbnum:'',//微博数
          ttnum:'',//头条数
          value:1,//管理员
          checkedSel:false,
          add:2,
          del:1,
          update:1,
          mtlist:1,//媒体榜单
          task:1,//任务平台
          tipsText:'请填写授权媒体号数量',
          active:false,
          active1:false,
          active2:false,
          active3:false,
          active4:false,
          powerId:'',
          
        }
    },
    mounted() {
    let that = this;
    that.typeId= that.$route.query.id;
	
    that.getinfo();
    
    },
    created() {
		
    },
    methods: {
      getinfo(){
        let that = this;
        that.$api.post('/user/getinfo',{id:that.typeId},r=>{
            that.$parent.returnCode(r,function(){
              that.powerId = r.data.id;
              that.type = r.data.type;
              that.wxnum = r.data.wxNum;
              that.wbnum = r.data.weiboNum;
              that.ttnum = r.data.ttNum;
              that.add = r.data.add;
              that.del = r.data.del;
              that.update = r.data.update;
              that.mtlist = r.data.check;
              that.task = r.data.task;
              if(that.type==1){
                that.sel =1;
              }else{
                that.sel =2;
              }
              if(that.add==1){
                that.active = true;
              }else{
                that.active = false;
              }
              if(that.del==1){
                that.active1 = true;
              }else{
                that.active1 = false;
              }
              if(that.update==1){
                that.active2 = true;
              }else{
                that.active2 = false;
              }
              if(that.mtlist==1){
                that.active3 = true;
              }else{
                that.active3 = false;
              }
              if(that.task==1){
                that.active4 = true;
              }else{
                that.active4 = false;
              }

          })
       })
      },
      cancel(){//取消
          this.$router.push({
              path: '/userManagement',
          });
        },
      typeCheck(type){//用户选择
        this.wxnum ='';
        this.wbnum ='';
        this.ttnum ='';
        if(type==2){
          this.mtlist=this.task=this.add =this.update=2;
          this.active3 = this.active4=false;
        }else{
          this.mtlist=1;
          this.task = 1;
          this.add = 1;
          this.del = 1;
          this.update = 1;
          this.active =true;
          this.active1 =true;
          this.active2 =true;
          this.active3 =true;
          this.active4 =true;
          
        }
      },
      taskChecked(){//任务派发
        let that =this;
        if(that.active4){
          that.task = 2;
        }else{
          that.task = 1;
        }
      },
      mtlistChecked(type){//媒体榜单
        let that= this;
        if(that.active3){
          that.mtlist = 2;
        }else{
          that.mtlist =1;
        }
        
      },
      addChecked(type){//添加账号
            let that = this; 
            if(that.active){
              that.add = 2;
            }else{
              that.add =1;
            }
            
            
        },
        delChecked(type){//删除账号
            let that = this; 
            if(that.active1){
              that.del = 2;
            }else{
              that.del = 1;
            }
          
        },
        updateChecked(type){//权限调整
            let that = this; 
            if(that.active2){
              that.update = 2;
            }else{
              that.update =1;
            }
           
        },
       dataAjax(){ //用户权限保存
           let that = this;
           if(that.wxnum==''||that.wbnum==''||that.ttnum==''){
             that.$utils.alertText(that.tipsText,200,3000);
             return;
           }
            that.$api.post('user/saverole',{id:that.powerId,type:that.sel,check:that.mtlist,task:that.task,wxnum:that.wxnum,weibonum:that.wbnum,ttnum:that.ttnum,add:that.add,del:that.del,update:that.update},r=>{
               that.$parent.returnCode(r,function(){
                // return;
                  that.$router.push({
                      path: '/userManagement?pages='+that.$route.query.pages,
                  });
              })
          })
           
       }
  },
  watch: {
    
  }
}
</script>



// WEBPACK FOOTER //
// src/page/userManagement/userPower.vue